'use client';

import React from 'react';
import Link from 'next/link';
export default function RefundPolicyPage() {
  return (
    <main style={{ fontFamily: "'DM Sans', 'Roboto', sans-serif", minHeight: '100vh', background: '#f8fafc' }}>
      {/* Navbar */}
      <nav style={{ backgroundColor: '#fff', padding: '16px 0', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            <img src="/assets/images/image-1778102925137.png" alt="HP Logo" width={91} height={61} style={{ objectFit: 'contain' }} />
          </Link>
          <Link href="/" style={{ color: 'rgb(49,107,156)', textDecoration: 'none', fontSize: '15px', fontWeight: 600 }}>← Back to Store</Link>
        </div>
      </nav>

      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #003366 0%, #0d5fa3 100%)', padding: '48px 40px', textAlign: 'center' }}>
        <h1 style={{ color: '#fff', fontSize: '36px', fontWeight: 800, margin: '0 0 12px' }}>Refund & Return Policy</h1>
        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px', margin: 0 }}>Last updated: January 1, 2026</p>
      </div>

      {/* Content */}
      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '48px 40px' }}>
        <div style={{ background: '#fff', borderRadius: '16px', padding: '48px', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>

          {/* Quick Summary */}
          <div style={{ background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: '12px', padding: '20px 24px', marginBottom: '36px' }}>
            <h3 style={{ color: '#0369a1', fontSize: '16px', fontWeight: 700, margin: '0 0 8px' }}>Quick Summary</h3>
            <ul style={{ color: '#0c4a6e', fontSize: '14px', lineHeight: 1.8, paddingLeft: '20px', margin: 0 }}>
              <li>30-day return window for physical products</li>
              <li>Full refund for defective or damaged items</li>
              <li>Free return shipping on defective products</li>
              <li>Refunds processed within 5–7 business days</li>
            </ul>
          </div>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>1. Return Eligibility</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', marginBottom: '12px' }}>
              To be eligible for a return, your item must meet the following conditions:
            </p>
            <ul style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}>Item must be returned within <strong>30 days</strong> of the delivery date</li>
              <li style={{ marginBottom: '8px' }}>Item must be in its original packaging with all accessories included</li>
              <li style={{ marginBottom: '8px' }}>Item must be unused or defective (not damaged by misuse)</li>
              <li style={{ marginBottom: '8px' }}>Proof of purchase (order confirmation) must be provided</li>
            </ul>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>2. Non-Returnable Items</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', marginBottom: '12px' }}>The following items cannot be returned:</p>
            <ul style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}>Ink cartridges and toner that have been opened or used</li>
              <li style={{ marginBottom: '8px' }}>Items damaged due to misuse, accidents, or unauthorized modifications</li>
              <li style={{ marginBottom: '8px' }}>Digital downloads or software licenses</li>
              <li style={{ marginBottom: '8px' }}>Items returned after the 30-day window</li>
            </ul>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>3. How to Initiate a Return</h2>
            <ol style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '12px' }}>Contact our support team at <a href="mailto:returns@barbprinterstore.online" style={{ color: 'rgb(49,107,156)' }}>returns@barbprinterstore.online</a> with your order number and reason for return.</li>
              <li style={{ marginBottom: '12px' }}>Our team will review your request within 1–2 business days and provide a Return Merchandise Authorization (RMA) number.</li>
              <li style={{ marginBottom: '12px' }}>Pack the item securely in its original packaging and include the RMA number on the outside of the box.</li>
              <li style={{ marginBottom: '12px' }}>Ship the item to the address provided by our support team.</li>
              <li style={{ marginBottom: '12px' }}>Once received and inspected, your refund will be processed within 5–7 business days.</li>
            </ol>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>4. Refund Processing</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              Once your return is received and inspected, we will send you an email notification. If approved, your refund will be processed and a credit will automatically be applied to your original payment method within <strong>5–7 business days</strong>. Please note that your bank or credit card company may take additional time to post the refund.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>5. Defective or Damaged Items</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              If you receive a defective or damaged item, please contact us within <strong>7 days</strong> of delivery with photos of the damage. We will arrange a free return shipping label and send a replacement or issue a full refund at no additional cost to you.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>6. Exchanges</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              We only replace items if they are defective or damaged. If you need to exchange a product for a different model, please return the original item for a refund and place a new order.
            </p>
          </section>

          <section>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>7. Contact Us</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              For return and refund inquiries, please contact us:<br />
              <strong>Email:</strong> <a href="mailto:returns@barbprinterstore.online" style={{ color: 'rgb(49,107,156)' }}>returns@barbprinterstore.online</a><br />
              <strong>Response Time:</strong> 1–2 business days
            </p>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ background: '#1e293b', padding: '32px 40px', marginTop: '40px' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
          <span style={{ color: '#94a3b8', fontSize: '14px' }}>© 2026 Barb Printer Store. All Rights Reserved.</span>
          <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
            <Link href="/privacy-policy" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</Link>
            <Link href="/terms-and-condition" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '14px' }}>Terms of Service</Link>
            <Link href="/refund-policy" style={{ color: '#7dd3fc', textDecoration: 'none', fontSize: '14px' }}>Refund Policy</Link>
            <Link href="/contact-us" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '14px' }}>Contact</Link>
          </div>
        </div>
      </footer>
    </main>
  );
}
